import {
  Box, Chip, Divider, FormControl, FormLabel, Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Grid } from "@mui/system";
import style from "../../../assets/css/proposal.module.scss";
import GlobalTextField from "../../global-fields/GlobalTextField";
import { useFormik } from "formik";
import * as Yup from "yup";
import NewProposalFooter from "./NewProposalFooter";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectAuthState } from "../../../store/authSlice";
import { selectDataStoreState, setDataStore } from "../../../store/dataSlice";
import { setUiData } from "../../../store/uiSlice";
import { PROPOSAL_FORM } from "../../../constants/apiConstant";
import {
  areRequiredFieldsFilled,
  initialFormValidations,
  parseToNumber,
  parseToNumberVersion2,
  removeCookies,
  USD_FORMATTER,
} from "../../../constants/helper";
import GlobalNotificationPopup from "../../global-fields/GlobalNotificationPopup";
import { motion } from "framer-motion";
import { fadeSlideIn } from "../../../constants/motionConstants";
import {
  amountSchemaWithRequired,
  amountSchemaWithoutRequired,
  optionalAmountSchema,
} from "../../../constants/validationSchemas";
import ShippingLocationAccordion from "./ShippingLimitAccordion";

const StepSevenForm = ({ leftGridWidth }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user, selectedClient } = useSelector(selectAuthState);
  const {
    proposalStep,
    propStep7Data,
    proposal_id,
    previous_proposal_id,
    editingSubmitted,
    formValidations,
  } = useSelector(selectDataStoreState);
  const [disableDraft, setDisableDraft] = useState(false);

  // const propStep7DataMemoize = useMemo(() => propStep7Data, [propStep7Data]);
  const propStep7DataMemoize = propStep7Data;
  const initialValuesOLD = {
    step: 7,
    registered_mail_under_section2:
      propStep7DataMemoize?.registered_mail_under_section2 == 0 ||
        propStep7DataMemoize?.registered_mail_under_section2 == "0" ||
        propStep7DataMemoize?.registered_mail_under_section2
        ? USD_FORMATTER.format(
          propStep7DataMemoize?.registered_mail_under_section2
        )
        : "$0",
    usps_express_mail_under_section2:
      propStep7DataMemoize?.usps_express_mail_under_section2 == 0 ||
        propStep7DataMemoize?.usps_express_mail_under_section2 == "0" ||
        propStep7DataMemoize?.usps_express_mail_under_section2
        ? USD_FORMATTER.format(
          propStep7DataMemoize?.usps_express_mail_under_section2
        )
        : "$0",
    armed_car_service_under_section2:
      propStep7DataMemoize?.armed_car_service_under_section2 == 0 ||
        propStep7DataMemoize?.armed_car_service_under_section2 == "0" ||
        propStep7DataMemoize?.armed_car_service_under_section2
        ? USD_FORMATTER.format(
          propStep7DataMemoize?.armed_car_service_under_section2
        )
        : "$0",
    airfreight_under_section2:
      propStep7DataMemoize?.airfreight_under_section2 == 0 ||
        propStep7DataMemoize?.airfreight_under_section2 == "0" ||
        propStep7DataMemoize?.airfreight_under_section2
        ? USD_FORMATTER.format(propStep7DataMemoize?.airfreight_under_section2)
        : "$0",
    fed_exp_ups_under_section2:
      propStep7DataMemoize?.fed_exp_ups_under_section2 == 0 ||
        propStep7DataMemoize?.fed_exp_ups_under_section2 == "0" ||
        propStep7DataMemoize?.fed_exp_ups_under_section2
        ? USD_FORMATTER.format(propStep7DataMemoize?.fed_exp_ups_under_section2)
        : "$0",
    secure_overnight_under_section2:
      propStep7DataMemoize?.secure_overnight_under_section2 == 0 ||
        propStep7DataMemoize?.secure_overnight_under_section2 == "0" ||
        propStep7DataMemoize?.secure_overnight_under_section2
        ? USD_FORMATTER.format(
          propStep7DataMemoize?.secure_overnight_under_section2
        )
        : "$0",
    registered_mail_within_usa_canada:
      propStep7DataMemoize?.registered_mail_within_usa_canada == 0 ||
        propStep7DataMemoize?.registered_mail_within_usa_canada == "0" ||
        propStep7DataMemoize?.registered_mail_within_usa_canada
        ? USD_FORMATTER.format(
          propStep7DataMemoize?.registered_mail_within_usa_canada
        )
        : "$0",
    armed_car_within_usa_canada:
      propStep7DataMemoize?.armed_car_within_usa_canada == 0 ||
        propStep7DataMemoize?.armed_car_within_usa_canada == "0" ||
        propStep7DataMemoize?.armed_car_within_usa_canada
        ? USD_FORMATTER.format(
          propStep7DataMemoize?.armed_car_within_usa_canada
        )
        : "$0",
    airfreight_within_usa_canada:
      propStep7DataMemoize?.airfreight_within_usa_canada == 0 ||
        propStep7DataMemoize?.airfreight_within_usa_canada == "0" ||
        propStep7DataMemoize?.airfreight_within_usa_canada
        ? USD_FORMATTER.format(
          propStep7DataMemoize?.airfreight_within_usa_canada
        )
        : "$0",
    fed_exp_ups_within_usa_canada:
      propStep7DataMemoize?.fed_exp_ups_within_usa_canada == 0 ||
        propStep7DataMemoize?.fed_exp_ups_within_usa_canada == "0" ||
        propStep7DataMemoize?.fed_exp_ups_within_usa_canada
        ? USD_FORMATTER.format(
          propStep7DataMemoize?.fed_exp_ups_within_usa_canada
        )
        : "$0",
    usps_express_mail_within_usa_canada:
      propStep7DataMemoize?.usps_express_mail_within_usa_canada == 0 ||
        propStep7DataMemoize?.usps_express_mail_within_usa_canada == "0" ||
        propStep7DataMemoize?.usps_express_mail_within_usa_canada
        ? USD_FORMATTER.format(
          propStep7DataMemoize?.usps_express_mail_within_usa_canada
        )
        : "$0",
    secure_overnight_within_usa_canada:
      propStep7DataMemoize?.secure_overnight_within_usa_canada == 0 ||
        propStep7DataMemoize?.secure_overnight_within_usa_canada == "0" ||
        propStep7DataMemoize?.secure_overnight_within_usa_canada
        ? USD_FORMATTER.format(
          propStep7DataMemoize?.secure_overnight_within_usa_canada
        )
        : "$0",
    registered_mail_elsewhere:
      propStep7DataMemoize?.registered_mail_elsewhere == 0 ||
        propStep7DataMemoize?.registered_mail_elsewhere == "0" ||
        propStep7DataMemoize?.registered_mail_elsewhere
        ? USD_FORMATTER.format(propStep7DataMemoize?.registered_mail_elsewhere)
        : "$0",
    armed_car_elsewhere:
      propStep7DataMemoize?.armed_car_elsewhere == 0 ||
        propStep7DataMemoize?.armed_car_elsewhere == "0" ||
        propStep7DataMemoize?.armed_car_elsewhere
        ? USD_FORMATTER.format(propStep7DataMemoize?.armed_car_elsewhere)
        : "$0",
    airfreight_elsewhere:
      propStep7DataMemoize?.airfreight_elsewhere == 0 ||
        propStep7DataMemoize?.airfreight_elsewhere == "0" ||
        propStep7DataMemoize?.airfreight_elsewhere
        ? USD_FORMATTER.format(propStep7DataMemoize?.airfreight_elsewhere)
        : "$0",
    fed_exp_ups_elsewhere:
      propStep7DataMemoize?.fed_exp_ups_elsewhere == 0 ||
        propStep7DataMemoize?.fed_exp_ups_elsewhere == "0" ||
        propStep7DataMemoize?.fed_exp_ups_elsewhere
        ? USD_FORMATTER.format(propStep7DataMemoize?.fed_exp_ups_elsewhere)
        : "$0",
    usps_express_mail_elsewhere:
      propStep7DataMemoize?.usps_express_mail_elsewhere == 0 ||
        propStep7DataMemoize?.usps_express_mail_elsewhere == "0" ||
        propStep7DataMemoize?.usps_express_mail_elsewhere
        ? USD_FORMATTER.format(
          propStep7DataMemoize?.usps_express_mail_elsewhere
        )
        : "$0",
    secure_overnight_elsewhere:
      propStep7DataMemoize?.secure_overnight_elsewhere == 0 ||
        propStep7DataMemoize?.secure_overnight_elsewhere == "0" ||
        propStep7DataMemoize?.secure_overnight_elsewhere
        ? USD_FORMATTER.format(propStep7DataMemoize?.secure_overnight_elsewhere)
        : "$0",
  };

  const shippingKeys = [
    "registered_mail_under_section2",
    "usps_express_mail_under_section2",
    "armed_car_service_under_section2",
    "airfreight_under_section2",
    "fed_exp_ups_under_section2",
    "secure_overnight_under_section2",
    "registered_mail_within_usa_canada",
    "armed_car_within_usa_canada",
    "airfreight_within_usa_canada",
    "fed_exp_ups_within_usa_canada",
    "usps_express_mail_within_usa_canada",
    "secure_overnight_within_usa_canada",
    "registered_mail_elsewhere",
    "armed_car_elsewhere",
    "airfreight_elsewhere",
    "fed_exp_ups_elsewhere",
    "usps_express_mail_elsewhere",
    "secure_overnight_elsewhere",
  ];

  // Helper function to format values safely
  const getFormattedValue = (value) => {
    return !!value ? USD_FORMATTER.format(value) : "$0";
  };

  const additional_locations =
    propStep7DataMemoize?.additional_addresses?.map((location) => {
      const obj = {
        location_id: location.location_id,
        location_name: `${location.street}, ${location.city}`,
        address: location.address,
      };

      shippingKeys.forEach((key) => {
        obj[key] = getFormattedValue(location[key]);
      });

      return obj;
    }) || [];

  // Final initial values
  const initialValues = shippingKeys.reduce(
    (acc, key) => {
      acc[key] = getFormattedValue(propStep7DataMemoize?.[key]);
      return acc;
    },
    { step: 7, additional_locations }
  );

  const initialValuesWithoutZero = {
    step: 7,
    registered_mail_under_section2:
      propStep7DataMemoize?.registered_mail_under_section2 == 0 ||
        propStep7DataMemoize?.registered_mail_under_section2 == "0" ||
        propStep7DataMemoize?.registered_mail_under_section2
        ? USD_FORMATTER.format(
          propStep7DataMemoize?.registered_mail_under_section2
        )
        : "",
    usps_express_mail_under_section2:
      propStep7DataMemoize?.usps_express_mail_under_section2 == 0 ||
        propStep7DataMemoize?.usps_express_mail_under_section2 == "0" ||
        propStep7DataMemoize?.usps_express_mail_under_section2
        ? USD_FORMATTER.format(
          propStep7DataMemoize?.usps_express_mail_under_section2
        )
        : "",
    armed_car_service_under_section2:
      propStep7DataMemoize?.armed_car_service_under_section2 == 0 ||
        propStep7DataMemoize?.armed_car_service_under_section2 == "0" ||
        propStep7DataMemoize?.armed_car_service_under_section2
        ? USD_FORMATTER.format(
          propStep7DataMemoize?.armed_car_service_under_section2
        )
        : "",
    airfreight_under_section2:
      propStep7DataMemoize?.airfreight_under_section2 == 0 ||
        propStep7DataMemoize?.airfreight_under_section2 == "0" ||
        propStep7DataMemoize?.airfreight_under_section2
        ? USD_FORMATTER.format(propStep7DataMemoize?.airfreight_under_section2)
        : "",
    fed_exp_ups_under_section2:
      propStep7DataMemoize?.fed_exp_ups_under_section2 == 0 ||
        propStep7DataMemoize?.fed_exp_ups_under_section2 == "0" ||
        propStep7DataMemoize?.fed_exp_ups_under_section2
        ? USD_FORMATTER.format(propStep7DataMemoize?.fed_exp_ups_under_section2)
        : "",
    registered_mail_within_usa_canada:
      propStep7DataMemoize?.registered_mail_within_usa_canada == 0 ||
        propStep7DataMemoize?.registered_mail_within_usa_canada == "0" ||
        propStep7DataMemoize?.registered_mail_within_usa_canada
        ? USD_FORMATTER.format(
          propStep7DataMemoize?.registered_mail_within_usa_canada
        )
        : "",
    armed_car_within_usa_canada:
      propStep7DataMemoize?.armed_car_within_usa_canada == 0 ||
        propStep7DataMemoize?.armed_car_within_usa_canada == "0" ||
        propStep7DataMemoize?.armed_car_within_usa_canada
        ? USD_FORMATTER.format(
          propStep7DataMemoize?.armed_car_within_usa_canada
        )
        : "",
    // all_other_within_usa_canada:
    //   propStep7DataMemoize?.all_other_within_usa_canada == 0 ||
    //     propStep7DataMemoize?.all_other_within_usa_canada == "0" ||
    //     propStep7DataMemoize?.all_other_within_usa_canada
    //     ? USD_FORMATTER.format(
    //       propStep7DataMemoize?.all_other_within_usa_canada
    //     )
    //     : "",
    airfreight_within_usa_canada:
      propStep7DataMemoize?.airfreight_within_usa_canada == 0 ||
        propStep7DataMemoize?.airfreight_within_usa_canada == "0" ||
        propStep7DataMemoize?.airfreight_within_usa_canada
        ? USD_FORMATTER.format(
          propStep7DataMemoize?.airfreight_within_usa_canada
        )
        : "",
    fed_exp_ups_within_usa_canada:
      propStep7DataMemoize?.fed_exp_ups_within_usa_canada == 0 ||
        propStep7DataMemoize?.fed_exp_ups_within_usa_canada == "0" ||
        propStep7DataMemoize?.fed_exp_ups_within_usa_canada
        ? USD_FORMATTER.format(
          propStep7DataMemoize?.fed_exp_ups_within_usa_canada
        )
        : "",
    // total_within_usa_canada:
    //   propStep7DataMemoize?.total_within_usa_canada == 0 ||
    //   propStep7DataMemoize?.total_within_usa_canada == "0" ||
    //   propStep7DataMemoize?.total_within_usa_canada
    //     ? USD_FORMATTER.format(propStep7DataMemoize?.total_within_usa_canada)
    //     : "",
    usps_express_mail_within_usa_canada:
      propStep7DataMemoize?.usps_express_mail_within_usa_canada == 0 ||
        propStep7DataMemoize?.usps_express_mail_within_usa_canada == "0" ||
        propStep7DataMemoize?.usps_express_mail_within_usa_canada
        ? USD_FORMATTER.format(
          propStep7DataMemoize?.usps_express_mail_within_usa_canada
        )
        : "",
    registered_mail_elsewhere:
      propStep7DataMemoize?.registered_mail_elsewhere == 0 ||
        propStep7DataMemoize?.registered_mail_elsewhere == "0" ||
        propStep7DataMemoize?.registered_mail_elsewhere
        ? USD_FORMATTER.format(propStep7DataMemoize?.registered_mail_elsewhere)
        : "",
    armed_car_elsewhere:
      propStep7DataMemoize?.armed_car_elsewhere == 0 ||
        propStep7DataMemoize?.armed_car_elsewhere == "0" ||
        propStep7DataMemoize?.armed_car_elsewhere
        ? USD_FORMATTER.format(propStep7DataMemoize?.armed_car_elsewhere)
        : "",
    // all_other_elsewhere:
    //   propStep7DataMemoize?.all_other_elsewhere == 0 ||
    //     propStep7DataMemoize?.all_other_elsewhere == "0" ||
    //     propStep7DataMemoize?.all_other_elsewhere
    //     ? USD_FORMATTER.format(propStep7DataMemoize?.all_other_elsewhere)
    //     : "",
    airfreight_elsewhere:
      propStep7DataMemoize?.airfreight_elsewhere == 0 ||
        propStep7DataMemoize?.airfreight_elsewhere == "0" ||
        propStep7DataMemoize?.airfreight_elsewhere
        ? USD_FORMATTER.format(propStep7DataMemoize?.airfreight_elsewhere)
        : "",
    fed_exp_ups_elsewhere:
      propStep7DataMemoize?.fed_exp_ups_elsewhere == 0 ||
        propStep7DataMemoize?.fed_exp_ups_elsewhere == "0" ||
        propStep7DataMemoize?.fed_exp_ups_elsewhere
        ? USD_FORMATTER.format(propStep7DataMemoize?.fed_exp_ups_elsewhere)
        : "",
    // total_elsewhere:
    //   propStep7DataMemoize?.total_elsewhere == 0 ||
    //   propStep7DataMemoize?.total_elsewhere == "0" ||
    //   propStep7DataMemoize?.total_elsewhere
    //     ? USD_FORMATTER.format(propStep7DataMemoize?.total_elsewhere)
    //     : "",
    usps_express_mail_elsewhere:
      propStep7DataMemoize?.usps_express_mail_elsewhere == 0 ||
        propStep7DataMemoize?.usps_express_mail_elsewhere == "0" ||
        propStep7DataMemoize?.usps_express_mail_elsewhere
        ? USD_FORMATTER.format(
          propStep7DataMemoize?.usps_express_mail_elsewhere
        )
        : "",
  };

  // useEffect(() => {
  //   if (propStep7DataMemoize) {
  //     formik.setValues(initialValues);
  //   }
  // }, [propStep7DataMemoize]);






  const handleStepData = (e) => {
    if (!proposal_id) {
      GlobalNotificationPopup({
        type: "error",
        message: "Please Fillout Initial/Business Details Form First.",
      });
      return;
    }
    dispatch(setUiData({ showLoader: true }));

    // let data = { ...e, user_id: user?.id, proposal_id, step: proposalStep };
    const shippingFields = [
      "registered_mail_under_section2",
      "usps_express_mail_under_section2",
      "armed_car_service_under_section2",
      "airfreight_under_section2",
      "fed_exp_ups_under_section2",
      "secure_overnight_under_section2",
      "registered_mail_within_usa_canada",
      "armed_car_within_usa_canada",
      "airfreight_within_usa_canada",
      "fed_exp_ups_within_usa_canada",
      "usps_express_mail_within_usa_canada",
      "secure_overnight_within_usa_canada",
      "registered_mail_elsewhere",
      "armed_car_elsewhere",
      "airfreight_elsewhere",
      "fed_exp_ups_elsewhere",
      "usps_express_mail_elsewhere",
      "secure_overnight_elsewhere",
    ];

    const additional_locations = (e.additional_locations || []).map((location) => {
      const obj = { ...location };

      shippingFields.forEach((field) => {
        obj[field] = parseToNumberVersion2(location[field]);
      });

      return obj;
    });
    let dataWithoutZero = {
      ...e,
      user_id: user?.id,
      proposal_id,
      proposal_status: editingSubmitted ? 1 : 0,
      previous_proposal_id: previous_proposal_id ?? null,
      step: proposalStep,
      // Unformatted amounts
      // registered_mail_under_section2: parseToNumberVersion2(
      //   e.registered_mail_under_section2
      // ),
      registered_mail_under_section2:
        e.registered_mail_under_section2 != "$0" &&
          parseToNumberVersion2(e.registered_mail_under_section2) == 0
          ? null
          : parseToNumberVersion2(e.registered_mail_under_section2),

      // usps_express_mail_under_section2: parseToNumberVersion2(
      //   e.usps_express_mail_under_section2
      // ),
      usps_express_mail_under_section2:
        e.usps_express_mail_under_section2 != "$0" &&
          parseToNumberVersion2(e.usps_express_mail_under_section2) == 0
          ? null
          : parseToNumberVersion2(e.usps_express_mail_under_section2),

      // armed_car_service_under_section2: parseToNumberVersion2(
      //   e.armed_car_service_under_section2
      // ),
      armed_car_service_under_section2:
        e.armed_car_service_under_section2 != "$0" &&
          parseToNumberVersion2(e.armed_car_service_under_section2) == 0
          ? null
          : parseToNumberVersion2(e.armed_car_service_under_section2),

      // airfreight_under_section2: parseToNumberVersion2(
      //   e.airfreight_under_section2
      // ),
      airfreight_under_section2:
        e.airfreight_under_section2 != "$0" &&
          parseToNumberVersion2(e.airfreight_under_section2) == 0
          ? null
          : parseToNumberVersion2(e.airfreight_under_section2),

      // fed_exp_ups_under_section2: parseToNumberVersion2(
      //   e.fed_exp_ups_under_section2
      // ),
      fed_exp_ups_under_section2:
        e.fed_exp_ups_under_section2 != "$0" &&
          parseToNumberVersion2(e.fed_exp_ups_under_section2) == 0
          ? null
          : parseToNumberVersion2(e.fed_exp_ups_under_section2),

      // registered_mail_within_usa_canada: parseToNumberVersion2(
      //   e.registered_mail_within_usa_canada
      // ),
      registered_mail_within_usa_canada:
        e.registered_mail_within_usa_canada != "$0" &&
          parseToNumberVersion2(e.registered_mail_within_usa_canada) == 0
          ? null
          : parseToNumberVersion2(e.registered_mail_within_usa_canada),

      // armed_car_within_usa_canada: parseToNumberVersion2(
      //   e.armed_car_within_usa_canada
      // ),
      armed_car_within_usa_canada:
        e.armed_car_within_usa_canada != "$0" &&
          parseToNumberVersion2(e.armed_car_within_usa_canada) == 0
          ? null
          : parseToNumberVersion2(e.armed_car_within_usa_canada),

      // all_other_within_usa_canada: parseToNumberVersion2(
      //   e.all_other_within_usa_canada
      // ),
      // airfreight_within_usa_canada: parseToNumberVersion2(
      //   e.airfreight_within_usa_canada
      // ),
      airfreight_within_usa_canada:
        e.airfreight_within_usa_canada != "$0" &&
          parseToNumberVersion2(e.airfreight_within_usa_canada) == 0
          ? null
          : parseToNumberVersion2(e.airfreight_within_usa_canada),

      // fed_exp_ups_within_usa_canada: parseToNumberVersion2(
      //   e.fed_exp_ups_within_usa_canada
      // ),
      fed_exp_ups_within_usa_canada:
        e.fed_exp_ups_within_usa_canada != "$0" &&
          parseToNumberVersion2(e.fed_exp_ups_within_usa_canada) == 0
          ? null
          : parseToNumberVersion2(e.fed_exp_ups_within_usa_canada),

      // total_within_usa_canada: parseToNumberVersion2(e.total_within_usa_canada),
      // usps_express_mail_within_usa_canada: parseToNumberVersion2(
      //   e.usps_express_mail_within_usa_canada
      // ),
      usps_express_mail_within_usa_canada:
        e.usps_express_mail_within_usa_canada != "$0" &&
          parseToNumberVersion2(e.usps_express_mail_within_usa_canada) == 0
          ? null
          : parseToNumberVersion2(e.usps_express_mail_within_usa_canada),

      // registered_mail_elsewhere: parseToNumberVersion2(
      //   e.registered_mail_elsewhere
      // ),
      registered_mail_elsewhere:
        e.registered_mail_elsewhere != "$0" &&
          parseToNumberVersion2(e.registered_mail_elsewhere) == 0
          ? null
          : parseToNumberVersion2(e.registered_mail_elsewhere),

      // armed_car_elsewhere: parseToNumberVersion2(e.armed_car_elsewhere),
      armed_car_elsewhere:
        e.armed_car_elsewhere != "$0" &&
          parseToNumberVersion2(e.armed_car_elsewhere) == 0
          ? null
          : parseToNumberVersion2(e.armed_car_elsewhere),

      // all_other_elsewhere: parseToNumberVersion2(e.all_other_elsewhere),
      // airfreight_elsewhere: parseToNumberVersion2(e.airfreight_elsewhere),
      airfreight_elsewhere:
        e.airfreight_elsewhere != "$0" &&
          parseToNumberVersion2(e.airfreight_elsewhere) == 0
          ? null
          : parseToNumberVersion2(e.airfreight_elsewhere),

      // fed_exp_ups_elsewhere: parseToNumberVersion2(e.fed_exp_ups_elsewhere),
      fed_exp_ups_elsewhere:
        e.fed_exp_ups_elsewhere != "$0" &&
          parseToNumberVersion2(e.fed_exp_ups_elsewhere) == 0
          ? null
          : parseToNumberVersion2(e.fed_exp_ups_elsewhere),

      // total_elsewhere: parseToNumberVersion2(e.total_elsewhere),
      // usps_express_mail_elsewhere: parseToNumberVersion2(
      //   e.usps_express_mail_elsewhere
      // ),
      usps_express_mail_elsewhere:
        e.usps_express_mail_elsewhere != "$0" &&
          parseToNumberVersion2(e.usps_express_mail_elsewhere) == 0
          ? null
          : parseToNumberVersion2(e.usps_express_mail_elsewhere),
    };
    let data = {
      ...e,
      additional_locations, 
      user_id: user?.id,
      proposal_id,
      step: proposalStep,
      registered_mail_under_section2: parseToNumberVersion2(
        e.registered_mail_under_section2
      ),
      usps_express_mail_under_section2: parseToNumberVersion2(
        e.usps_express_mail_under_section2
      ),
      armed_car_service_under_section2: parseToNumberVersion2(
        e.armed_car_service_under_section2
      ),
      airfreight_under_section2: parseToNumberVersion2(
        e.airfreight_under_section2
      ),
      fed_exp_ups_under_section2: parseToNumberVersion2(
        e.fed_exp_ups_under_section2
      ),
      secure_overnight_under_section2: parseToNumberVersion2(
        e.secure_overnight_under_section2
      ),
      registered_mail_within_usa_canada: parseToNumberVersion2(
        e.registered_mail_within_usa_canada
      ),
      armed_car_within_usa_canada: parseToNumberVersion2(
        e.armed_car_within_usa_canada
      ),
      airfreight_within_usa_canada: parseToNumberVersion2(
        e.airfreight_within_usa_canada
      ),
      fed_exp_ups_within_usa_canada: parseToNumberVersion2(
        e.fed_exp_ups_within_usa_canada
      ),
      usps_express_mail_within_usa_canada: parseToNumberVersion2(
        e.usps_express_mail_within_usa_canada
      ),
      secure_overnight_within_usa_canada: parseToNumberVersion2(
        e.secure_overnight_within_usa_canada
      ),
      registered_mail_elsewhere: parseToNumberVersion2(
        e.registered_mail_elsewhere
      ),
      armed_car_elsewhere: parseToNumberVersion2(e.armed_car_elsewhere),
      airfreight_elsewhere: parseToNumberVersion2(e.airfreight_elsewhere),
      fed_exp_ups_elsewhere: parseToNumberVersion2(e.fed_exp_ups_elsewhere),
      usps_express_mail_elsewhere: parseToNumberVersion2(
        e.usps_express_mail_elsewhere
      ),
      secure_overnight_elsewhere: parseToNumberVersion2(
        e.secure_overnight_elsewhere
      ),
    };

    if (user?.user_type === "agent") {
      data = { ...data, user_id: selectedClient?.user_id, agent_id: user?.id };
    }
    const options = {
      method: PROPOSAL_FORM.method,
      headers: PROPOSAL_FORM.headers,
      body: JSON.stringify(data),
    };

    fetch(PROPOSAL_FORM.url, options)
      .then((response) => response.json())
      .then((res) => {
        if (res.status == 0) {
          dispatch(setUiData({ showLoader: false }));
          formik.resetForm();
        } else if (res.status == 1) {
          dispatch(
            setDataStore({
              proposalStep: proposalStep + 1,
            })
          );
          dispatch(setUiData({ showLoader: false }));
        }
        if (e?.save_draft) {
          setDisableDraft(false);
        }
      })
      .catch((error) => {
        dispatch(
          setDataStore({
            proposalStep: 1,
            proposal_id: null,
            previous_proposal_id: null,
            editingSubmitted: false,
            clickedSteps: [],
            formValidations: initialFormValidations,
          })
        );
        removeCookies("isLogin");
        GlobalNotificationPopup({ type: "error", message: error });
        console.log("error", error);
        dispatch(setUiData({ showLoader: false }));
        navigate("/");
        formik.resetForm();
      });
  };

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: Yup.object({
      registered_mail_under_section2: optionalAmountSchema,
      usps_express_mail_under_section2: amountSchemaWithRequired,
      armed_car_service_under_section2: amountSchemaWithRequired,
      airfreight_under_section2: amountSchemaWithRequired,
      fed_exp_ups_under_section2: amountSchemaWithRequired,
      secure_overnight_under_section2: amountSchemaWithoutRequired,
      registered_mail_within_usa_canada: amountSchemaWithRequired,
      armed_car_within_usa_canada: amountSchemaWithRequired,
      // all_other_within_usa_canada: amountSchemaWithoutRequired,
      airfreight_within_usa_canada: amountSchemaWithRequired,
      fed_exp_ups_within_usa_canada: amountSchemaWithRequired,
      // total_within_usa_canada: amountSchemaWithoutRequired,
      secure_overnight_within_usa_canada: amountSchemaWithRequired,
      usps_express_mail_within_usa_canada: amountSchemaWithRequired,
      registered_mail_elsewhere: amountSchemaWithRequired,
      armed_car_elsewhere: amountSchemaWithRequired,
      // all_other_elsewhere: amountSchemaWithoutRequired,
      airfreight_elsewhere: amountSchemaWithRequired,
      fed_exp_ups_elsewhere: amountSchemaWithRequired,
      // total_elsewhere: amountSchemaWithoutRequired,
      usps_express_mail_elsewhere: amountSchemaWithRequired,
      secure_overnight_elsewhere: amountSchemaWithRequired,
    }),
    onSubmit: (values) => {
      //console.log("Form submitted 7:", values);
      handleStepData(values);
    },
  });
  const handleCustomSubmit = async (e) => {
    const errors = await formik.validateForm();

    if (Object.keys(errors).length > 0) {
      const updated = formValidations.map((item) => {
        if (item.step === 7) {
          return { ...item, status: 2 };
        }
        return item;
      });

      dispatch(
        setDataStore({
          formValidations: updated,
        })
      );

      formik.handleSubmit(); // still runs to show errors
    } else {
      formik.handleSubmit(); // successful submit
    }
  };

  const handleAmountFieldChangeOLD = (e, fieldName) => {
    const rawValue = e.target.value;
    const numericValue = parseToNumber(rawValue);
    formik.setFieldValue(
      fieldName,
      numericValue !== "" ? USD_FORMATTER.format(numericValue) : ""
    );
  };


  const handleAmountFieldChangeNew = (e, fieldName) => {
    let rawValue = e.target.value;

    // Allow clearing the field
    if (rawValue === "") {
      formik.setFieldValue(fieldName, "");
      return;
    }

    // Ensure it always starts with $
    if (!rawValue.startsWith("$")) rawValue = "$" + rawValue;

    // Extract numeric part
    const numericValue = parseToNumber(rawValue);

    // Allow typing "$" or "$."
    if (rawValue === "$" || rawValue === "$.") {
      formik.setFieldValue(fieldName, rawValue);
      return;
    }

    // Format integer part with commas
    let formatted = "$";
    if (numericValue !== "") {
      const [integerPart, decimalPart] = rawValue
        .replace(/[^0-9.]/g, "")
        .split(".");

      formatted += new Intl.NumberFormat("en-US").format(Number(integerPart));

      if (decimalPart !== undefined) {
        formatted += "." + decimalPart.slice(0, 2);
      }
    }

    formik.setFieldValue(fieldName, formatted);
  };
  const handleAmountFieldChange = (e, fieldName) => {
    let rawValue = e.target.value;

    // Ensure it always starts with $
    if (!rawValue.startsWith("$")) rawValue = "$" + rawValue;

    // Extract numeric part
    const numericValue = parseToNumber(rawValue);

    // Allow typing "$" or "$." without formatting
    if (rawValue === "$" || rawValue === "$.") {
      formik.setFieldValue(fieldName, rawValue);
      return;
    }

    // Format integer part with commas, keep decimal part as typed
    let formatted = "$";
    if (numericValue !== "") {
      const [integerPart, decimalPart] = rawValue
        .replace(/[^0-9.]/g, "")
        .split(".");

      // Format integer with commas
      formatted += new Intl.NumberFormat("en-US").format(Number(integerPart));

      // Append decimal part if exists, limit to 2 digits
      if (decimalPart !== undefined) {
        formatted += "." + decimalPart.slice(0, 2);
      }
    }

    formik.setFieldValue(fieldName, formatted);
  };
  //console.log("formik", propStep7DataMemoize, formik);
  // console.log(
  //   "formik",
  //   formik.dirty,
  //   formik.values,
  //   formik.errors,
  //   formik.values && Object.values(formik.values).some((value) => value == "") === false &&
  //           !formik.dirty &&
  //           propStep7DataMemoize !== null
  // );
  // console.log("propStep5DataMemoize", propStep5DataMemoize);
  // console.log("areRequiredFieldsFilled",areRequiredFieldsFilled(formik))
  const filteredData = Object.fromEntries(
    Object.entries(propStep7DataMemoize || {}).filter(
      ([key]) =>
        !["id", "proposal_id", "user_id", "previous_proposal_id"].includes(key)
    )
  );
  const hasNull = Object.values(filteredData).some((value) => value === null);

  const handleSaveDraft = useCallback(() => {
    const { values } = formik;
    setDisableDraft(true);
    let vals = { ...values, save_draft: true };
    // console.log("vals", vals);
    //return;
    handleStepData(vals);
  }, [formik]);

  return (
    <>
      <section className={style.proposalMain}>
        <motion.div {...fadeSlideIn}>
          <Box className={style.proposalMainD}>
            {selectedClient !== null ? (
              <div className={style.client_title}>
                <p> On behalf of Client : </p>
                <h3>
                  {selectedClient?.first_name} {selectedClient?.last_name}
                </h3>
                {/* <span>{selectedClient?.email} </span> */}
                <Divider />
              </div>
            ) : null}
            <h2 className={style.propo_title}>Shipping Limits & Exposure</h2>
            <Box sx={{ mb: 1.9 }}>
              <p className={style.htitleText + " " + style.noteText}>
                <u>Note</u> : Secure Overnight Shipments are the shipments that
                go through Parcel Pro/IFS or Similar.
              </p>
            </Box>
            <form
              autoComplete="false"
              autoSave="false"
              onSubmit={handleCustomSubmit}
            >

              <Accordion
                defaultExpanded
                sx={{
                  mb: 2, // Space between accordions
                  borderRadius: "8px",
                  overflow: "hidden",
                  boxShadow: "none",
                  border: "1px solid #d9e2ec",
                  "&:before": {
                    display: "none",
                  },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{
                    backgroundColor: "#f5f9fc", // Light blue background
                    minHeight: "56px",
                    "& .MuiAccordionSummary-content": {
                      margin: "12px 0",
                    },
                    "&.Mui-expanded": {
                      minHeight: "56px",
                    },
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      color: "#0b5c7c",
                      fontWeight: 600,
                    }}
                  >
                    Default Location
                  </Typography>
                </AccordionSummary>

                <AccordionDetails
                  sx={{
                    p: 3, // Increase inner spacing
                    backgroundColor: "#fff",
                  }}
                >

                  <Grid container spacing={2}>
                    <Grid size={{ xs: 12 }}>
                      <h2 className={style.formTitleh2}>
                        15) What limits do you desire for section 2 of the policy?
                      </h2>
                    </Grid>
                    <Grid size={{ xs: 12, xl: 2, lg: 4, sm: 4 }}>
                      <Box sx={{ mb: 1 }}>
                        <h3 className={style.htitleText}>Registered Mail *</h3>
                      </Box>
                      <GlobalTextField
                        placeH="$"
                        type="text"
                        name={`registered_mail_under_section2`}
                        id={`_registered_mail_under_section2`}
                        value={formik.values?.registered_mail_under_section2}
                        onChange={(e) =>
                          handleAmountFieldChangeNew(
                            e,
                            "registered_mail_under_section2"
                          )
                        }
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched?.registered_mail_under_section2 &&
                          Boolean(formik.errors?.registered_mail_under_section2)
                        }
                        helperText={
                          formik.touched?.registered_mail_under_section2 &&
                          formik.errors?.registered_mail_under_section2
                        }
                      />
                    </Grid>
                    <Grid size={{ xs: 12, xl: 2, lg: 4, sm: 4 }}>
                      <Box sx={{ mb: 1 }}>
                        <h3 className={style.htitleText}>Armored Car Service *</h3>
                      </Box>
                      <GlobalTextField
                        placeH="$"
                        type="text"
                        name={`armed_car_service_under_section2`}
                        id={`_armed_car_service_under_section2`}
                        value={formik.values?.armed_car_service_under_section2}
                        onChange={(e) =>
                          handleAmountFieldChange(
                            e,
                            "armed_car_service_under_section2"
                          )
                        }
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched?.armed_car_service_under_section2 &&
                          Boolean(formik.errors?.armed_car_service_under_section2)
                        }
                        helperText={
                          formik.touched?.armed_car_service_under_section2 &&
                          formik.errors?.armed_car_service_under_section2
                        }
                      />
                    </Grid>
                    <Grid size={{ xs: 12, xl: 2, lg: 4, sm: 4 }}>
                      <Box sx={{ mb: 1 }}>
                        <h3 className={style.htitleText}>Airfreight *</h3>
                      </Box>
                      <GlobalTextField
                        placeH="$"
                        type="text"
                        name={`airfreight_under_section2`}
                        id={`_airfreight_under_section2`}
                        value={formik.values?.airfreight_under_section2}
                        onChange={(e) =>
                          handleAmountFieldChange(e, "airfreight_under_section2")
                        }
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched?.airfreight_under_section2 &&
                          Boolean(formik.errors?.airfreight_under_section2)
                        }
                        helperText={
                          formik.touched?.airfreight_under_section2 &&
                          formik.errors?.airfreight_under_section2
                        }
                      />
                    </Grid>
                    <Grid size={{ xs: 12, xl: 2, lg: 4, sm: 4 }}>
                      <Box sx={{ mb: 1 }}>
                        <h3 className={style.htitleText}>
                          Fed Exp/UPS or Similar *
                        </h3>
                      </Box>
                      <GlobalTextField
                        placeH="$"
                        type="text"
                        name={`fed_exp_ups_under_section2`}
                        id={`_fed_exp_ups_under_section2`}
                        value={formik.values?.fed_exp_ups_under_section2}
                        onChange={(e) =>
                          handleAmountFieldChange(e, "fed_exp_ups_under_section2")
                        }
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched?.fed_exp_ups_under_section2 &&
                          Boolean(formik.errors?.fed_exp_ups_under_section2)
                        }
                        helperText={
                          formik.touched?.fed_exp_ups_under_section2 &&
                          formik.errors?.fed_exp_ups_under_section2
                        }
                      />
                    </Grid>
                    <Grid size={{ xs: 12, xl: 2, lg: 4, sm: 4 }}>
                      <Box sx={{ mb: 1 }}>
                        <h3 className={style.htitleText}>USPS Express Mail *</h3>
                      </Box>
                      <GlobalTextField
                        placeH="$"
                        type="text"
                        name={`usps_express_mail_under_section2`}
                        id={`_usps_express_mail_under_section2`}
                        value={formik.values?.usps_express_mail_under_section2}
                        onChange={(e) =>
                          handleAmountFieldChange(
                            e,
                            "usps_express_mail_under_section2"
                          )
                        }
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched?.usps_express_mail_under_section2 &&
                          Boolean(formik.errors?.usps_express_mail_under_section2)
                        }
                        helperText={
                          formik.touched?.usps_express_mail_under_section2 &&
                          formik.errors?.usps_express_mail_under_section2
                        }
                      />
                    </Grid>
                    <Grid size={{ xs: 12, xl: 2, lg: 4, sm: 4 }}>
                      <Box sx={{ mb: 1 }}>
                        <h3 className={style.htitleText}>Secure Overnight *</h3>
                      </Box>
                      <GlobalTextField
                        placeH="$"
                        type="text"
                        name={`secure_overnight_under_section2`}
                        id={`_secure_overnight_under_section2`}
                        value={formik.values?.secure_overnight_under_section2}
                        onChange={(e) =>
                          handleAmountFieldChange(
                            e,
                            "secure_overnight_under_section2"
                          )
                        }
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched?.secure_overnight_under_section2 &&
                          Boolean(formik.errors?.secure_overnight_under_section2)
                        }
                        helperText={
                          formik.touched?.secure_overnight_under_section2 &&
                          formik.errors?.secure_overnight_under_section2
                        }
                      />
                    </Grid>
                  </Grid>

                  <Grid container spacing={2}>
                    <Grid size={{ xs: 12 }} sx={{ mt: 4 }}>
                      <Grid size={{ xs: 12 }}>
                        <h2 className={style.formTitleh2}>
                          16) Property Outside of our Premises as set forth in
                          question
                        </h2>
                      </Grid>
                      <Box sx={{ mt: 1 }}>
                        <p className={style.htitleText}>
                          Shipments the total amount of property shipped at our risk
                          during the last 12 months did not exceed:
                        </p>
                      </Box>
                      <Box sx={{ mt: 1 }}>
                        <h3
                          style={{ fontWeight: "600" }}
                          className={style.htitleText}
                        >
                          Within USA and/or Canada
                        </h3>
                      </Box>
                    </Grid>
                    <Grid size={{ xs: 12, xl: 2, lg: 4, sm: 4 }}>
                      <Box sx={{ mb: 1 }}>
                        <h3 className={style.htitleText}>Registered Mail *</h3>
                      </Box>
                      <GlobalTextField
                        placeH="$"
                        type="text"
                        name={`registered_mail_within_usa_canada`}
                        id={`_registered_mail_within_usa_canada`}
                        value={formik.values?.registered_mail_within_usa_canada}
                        // onChange={(e) =>
                        //   handleChangeAndUpdateTotalWithin(
                        //     "registered_mail_within_usa_canada",
                        //     e.target.value
                        //   )
                        // }
                        onChange={(e) =>
                          handleAmountFieldChange(
                            e,
                            "registered_mail_within_usa_canada"
                          )
                        }
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched?.registered_mail_within_usa_canada &&
                          Boolean(formik.errors?.registered_mail_within_usa_canada)
                        }
                        helperText={
                          formik.touched?.registered_mail_within_usa_canada &&
                          formik.errors?.registered_mail_within_usa_canada
                        }
                      />
                    </Grid>

                    <Grid size={{ xs: 12, xl: 2, lg: 4, sm: 4 }}>
                      <Box sx={{ mb: 1 }}>
                        <h3 className={style.htitleText}>Armored Car Service *</h3>
                      </Box>
                      <GlobalTextField
                        placeH="$"
                        type="text"
                        name={`armed_car_within_usa_canada`}
                        id={`_armed_car_within_usa_canada`}
                        value={formik.values?.armed_car_within_usa_canada}
                        // onChange={(e) =>
                        //   handleChangeAndUpdateTotalWithin(
                        //     "armed_car_within_usa_canada",
                        //     e.target.value
                        //   )
                        // }
                        onChange={(e) =>
                          handleAmountFieldChange(e, "armed_car_within_usa_canada")
                        }
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched?.armed_car_within_usa_canada &&
                          Boolean(formik.errors?.armed_car_within_usa_canada)
                        }
                        helperText={
                          formik.touched?.armed_car_within_usa_canada &&
                          formik.errors?.armed_car_within_usa_canada
                        }
                      />
                    </Grid>

                    {/* <Grid size={{xs: 12, xl:2.4, lg:6, sm: 6}}>
                  <FormControl fullWidth>
                    <FormLabel sx={{mb: 1}}> Total </FormLabel>
                  </FormControl>
                  <GlobalTextField
                    placeH="$"
                    type="text"
                    name={`total_within_usa_canada`}
                    id={`_total_within_usa_canada`}
                    value={formik.values?.total_within_usa_canada}
                    error={
                      formik.touched?.total_within_usa_canada &&
                      Boolean(formik.errors?.total_within_usa_canada)
                    }
                    helperText={
                      formik.touched?.total_within_usa_canada &&
                      formik.errors?.total_within_usa_canada
                    }
                    disabled
                  />
                </Grid> */}
                    <Grid size={{ xs: 12, xl: 2, lg: 4, sm: 4 }}>
                      <Box sx={{ mb: 1 }}>
                        <h3 className={style.htitleText}>Airfreight *</h3>
                      </Box>
                      <GlobalTextField
                        placeH="$"
                        type="text"
                        name={`airfreight_within_usa_canada`}
                        id={`_airfreight_within_usa_canada`}
                        value={formik.values?.airfreight_within_usa_canada}
                        onChange={(e) =>
                          handleAmountFieldChange(e, "airfreight_within_usa_canada")
                        }
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched?.airfreight_within_usa_canada &&
                          Boolean(formik.errors?.airfreight_within_usa_canada)
                        }
                        helperText={
                          formik.touched?.airfreight_within_usa_canada &&
                          formik.errors?.airfreight_within_usa_canada
                        }
                      />
                    </Grid>
                    <Grid size={{ xs: 12, xl: 2, lg: 4, sm: 4 }}>
                      <Box sx={{ mb: 1 }}>
                        <h3 className={style.htitleText}>
                          Fed Exp/UPS or Similar *
                        </h3>
                      </Box>
                      <GlobalTextField
                        placeH="$"
                        type="text"
                        name={`fed_exp_ups_within_usa_canada`}
                        id={`_fed_exp_ups_within_usa_canada`}
                        value={formik.values?.fed_exp_ups_within_usa_canada}
                        onChange={(e) =>
                          handleAmountFieldChange(
                            e,
                            "fed_exp_ups_within_usa_canada"
                          )
                        }
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched?.fed_exp_ups_within_usa_canada &&
                          Boolean(formik.errors?.fed_exp_ups_within_usa_canada)
                        }
                        helperText={
                          formik.touched?.fed_exp_ups_within_usa_canada &&
                          formik.errors?.fed_exp_ups_within_usa_canada
                        }
                      />
                    </Grid>
                    <Grid size={{ xs: 12, xl: 2, lg: 4, sm: 4 }}>
                      <Box sx={{ mb: 1 }}>
                        <h3 className={style.htitleText}>USPS Express Mail *</h3>
                      </Box>
                      <GlobalTextField
                        placeH="$"
                        type="text"
                        name={`usps_express_mail_within_usa_canada`}
                        id={`_usps_express_mail_within_usa_canada`}
                        value={formik.values?.usps_express_mail_within_usa_canada}
                        onChange={(e) =>
                          handleAmountFieldChange(
                            e,
                            "usps_express_mail_within_usa_canada"
                          )
                        }
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched?.usps_express_mail_within_usa_canada &&
                          Boolean(
                            formik.errors?.usps_express_mail_within_usa_canada
                          )
                        }
                        helperText={
                          formik.touched?.usps_express_mail_within_usa_canada &&
                          formik.errors?.usps_express_mail_within_usa_canada
                        }
                      />
                    </Grid>
                    <Grid size={{ xs: 12, xl: 2, lg: 4, sm: 4 }}>
                      <Box sx={{ mb: 1 }}>
                        <h3 className={style.htitleText}>Secure Overnight *</h3>
                      </Box>
                      <GlobalTextField
                        placeH="$"
                        type="text"
                        name={`secure_overnight_within_usa_canada`}
                        id={`_secure_overnight_within_usa_canada`}
                        value={formik.values?.secure_overnight_within_usa_canada}
                        onChange={(e) =>
                          handleAmountFieldChange(
                            e,
                            "secure_overnight_within_usa_canada"
                          )
                        }
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched?.secure_overnight_within_usa_canada &&
                          Boolean(formik.errors?.secure_overnight_within_usa_canada)
                        }
                        helperText={
                          formik.touched?.secure_overnight_within_usa_canada &&
                          formik.errors?.secure_overnight_within_usa_canada
                        }
                      />
                    </Grid>
                    {/* <Grid size={{ xs: 12, xl:2, lg:2, sm:4 }}>
                  <FormControl fullWidth>
                    <FormLabel sx={{ mb: 1 }}> All Other </FormLabel>
                  </FormControl>
                  <GlobalTextField
                    placeH="$"
                    type="text"
                    name={`all_other_within_usa_canada`}
                    id={`_all_other_within_usa_canada`}
                    value={formik.values?.all_other_within_usa_canada}
                    onChange={(e) =>
                      handleChangeAndUpdateTotalWithin(
                        "all_other_within_usa_canada",
                        e.target.value
                      )
                    }
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched?.all_other_within_usa_canada &&
                      Boolean(formik.errors?.all_other_within_usa_canada)
                    }
                    helperText={
                      formik.touched?.all_other_within_usa_canada &&
                      formik.errors?.all_other_within_usa_canada
                    }
                  />
                </Grid> */}
                  </Grid>

                  <Grid container spacing={2}>
                    <Grid size={{ xs: 12 }} sx={{ mt: 2 }}>
                      <Box sx={{ mt: 1 }}>
                        <h3
                          className={style.htitleText}
                          style={{ fontWeight: "600" }}
                        >
                          Elsewhere
                        </h3>
                      </Box>
                    </Grid>
                    <Grid size={{ xs: 12, xl: 2, lg: 4, sm: 4 }}>
                      <Box sx={{ mb: 1 }}>
                        <h3 className={style.htitleText}>Registered Mail *</h3>
                      </Box>
                      <GlobalTextField
                        placeH="$"
                        type="text"
                        name={`registered_mail_elsewhere`}
                        id={`_registered_mail_elsewhere`}
                        value={formik.values?.registered_mail_elsewhere}
                        // onChange={(e) =>
                        //   handleChangeAndUpdateTotalElsewhere(
                        //     "registered_mail_elsewhere",
                        //     e.target.value
                        //   )
                        // }
                        onChange={(e) =>
                          handleAmountFieldChange(e, "registered_mail_elsewhere")
                        }
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched?.registered_mail_elsewhere &&
                          Boolean(formik.errors?.registered_mail_elsewhere)
                        }
                        helperText={
                          formik.touched?.registered_mail_elsewhere &&
                          formik.errors?.registered_mail_elsewhere
                        }
                      />
                    </Grid>

                    <Grid size={{ xs: 12, xl: 2, lg: 4, sm: 4 }}>
                      <Box sx={{ mb: 1 }}>
                        <h3 className={style.htitleText}>Armored Car Service *</h3>
                      </Box>
                      <GlobalTextField
                        placeH="$"
                        type="text"
                        name={`armed_car_elsewhere`}
                        id={`_armed_car_elsewhere`}
                        value={formik.values?.armed_car_elsewhere}
                        // onChange={(e) =>
                        //   handleChangeAndUpdateTotalElsewhere(
                        //     "armed_car_elsewhere",
                        //     e.target.value
                        //   )
                        // }
                        onChange={(e) =>
                          handleAmountFieldChange(e, "armed_car_elsewhere")
                        }
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched?.armed_car_elsewhere &&
                          Boolean(formik.errors?.armed_car_elsewhere)
                        }
                        helperText={
                          formik.touched?.armed_car_elsewhere &&
                          formik.errors?.armed_car_elsewhere
                        }
                      />
                    </Grid>

                    {/* <Grid size={{xs: 12, xl:2.4, lg:6, sm: 6}}>
                  <FormControl fullWidth>
                    <FormLabel sx={{mb: 1}}> Total </FormLabel>
                  </FormControl>
                  <GlobalTextField
                    placeH="$"
                    type="text"
                    name={`total_elsewhere`}
                    id={`_total_elsewhere`}
                    value={formik.values?.total_elsewhere}
                    error={
                      formik.touched?.total_elsewhere &&
                      Boolean(formik.errors?.total_elsewhere)
                    }
                    helperText={
                      formik.touched?.total_elsewhere &&
                      formik.errors?.total_elsewhere
                    }
                    disabled
                  />
                </Grid> */}
                    <Grid size={{ xs: 12, xl: 2, lg: 4, sm: 4 }}>
                      <Box sx={{ mb: 1 }}>
                        <h3 className={style.htitleText}> Airfreight </h3>
                      </Box>
                      <GlobalTextField
                        placeH="$"
                        type="text"
                        name={`airfreight_elsewhere`}
                        id={`_airfreight_elsewhere`}
                        value={formik.values?.airfreight_elsewhere}
                        onChange={(e) =>
                          handleAmountFieldChange(e, "airfreight_elsewhere")
                        }
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched?.airfreight_elsewhere &&
                          Boolean(formik.errors?.airfreight_elsewhere)
                        }
                        helperText={
                          formik.touched?.airfreight_elsewhere &&
                          formik.errors?.airfreight_elsewhere
                        }
                      />
                    </Grid>
                    <Grid size={{ xs: 12, xl: 2, lg: 4, sm: 4 }}>
                      <Box sx={{ mb: 1 }}>
                        <h3 className={style.htitleText}>
                          Fed Exp/UPS or Similar *
                        </h3>
                      </Box>
                      <GlobalTextField
                        placeH="$"
                        type="text"
                        name={`fed_exp_ups_elsewhere`}
                        id={`_fed_exp_ups_elsewhere`}
                        value={formik.values?.fed_exp_ups_elsewhere}
                        onChange={(e) =>
                          handleAmountFieldChange(e, "fed_exp_ups_elsewhere")
                        }
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched?.fed_exp_ups_elsewhere &&
                          Boolean(formik.errors?.fed_exp_ups_elsewhere)
                        }
                        helperText={
                          formik.touched?.fed_exp_ups_elsewhere &&
                          formik.errors?.fed_exp_ups_elsewhere
                        }
                      />
                    </Grid>
                    <Grid size={{ xs: 12, xl: 2, lg: 4, sm: 4 }}>
                      <Box sx={{ mb: 1 }}>
                        <h3 className={style.htitleText}>USPS Express Mail * </h3>
                      </Box>
                      <GlobalTextField
                        placeH="$"
                        type="text"
                        name={`usps_express_mail_elsewhere`}
                        id={`_usps_express_mail_elsewhere`}
                        value={formik.values?.usps_express_mail_elsewhere}
                        onChange={(e) =>
                          handleAmountFieldChange(e, "usps_express_mail_elsewhere")
                        }
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched?.usps_express_mail_elsewhere &&
                          Boolean(formik.errors?.usps_express_mail_elsewhere)
                        }
                        helperText={
                          formik.touched?.usps_express_mail_elsewhere &&
                          formik.errors?.usps_express_mail_elsewhere
                        }
                      />
                    </Grid>
                    <Grid size={{ xs: 12, xl: 2, lg: 4, sm: 4 }}>
                      <Box sx={{ mb: 1 }}>
                        <h3 className={style.htitleText}>Secure Overnight *</h3>
                      </Box>
                      <GlobalTextField
                        placeH="$"
                        type="text"
                        name={`secure_overnight_elsewhere`}
                        id={`_secure_overnight_elsewhere`}
                        value={formik.values?.secure_overnight_elsewhere}
                        onChange={(e) =>
                          handleAmountFieldChange(e, "secure_overnight_elsewhere")
                        }
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched?.secure_overnight_elsewhere &&
                          Boolean(formik.errors?.secure_overnight_elsewhere)
                        }
                        helperText={
                          formik.touched?.secure_overnight_elsewhere &&
                          formik.errors?.secure_overnight_elsewhere
                        }
                      />
                    </Grid>
                    {/* <Grid size={{ xs: 12, xl:2, lg:2, sm:4 }}>
                  <FormControl fullWidth>
                    <FormLabel sx={{ mb: 1 }}> All Other </FormLabel>
                  </FormControl>
                  <GlobalTextField
                    placeH="$"
                    type="text"
                    name={`all_other_elsewhere`}
                    id={`_all_other_elsewhere`}
                    value={formik.values?.all_other_elsewhere}
                    onChange={(e) =>
                      handleChangeAndUpdateTotalElsewhere(
                        "all_other_elsewhere",
                        e.target.value
                      )
                    }
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched?.all_other_elsewhere &&
                      Boolean(formik.errors?.all_other_elsewhere)
                    }
                    helperText={
                      formik.touched?.all_other_elsewhere &&
                      formik.errors?.all_other_elsewhere
                    }
                  />
                </Grid> */}
                  </Grid>
                </AccordionDetails>
              </Accordion>

              {formik.values.additional_locations?.map((location, index) => (
                <ShippingLocationAccordion
                  key={location.location_id}
                  title={location.location_name || `Location ${index + 1}`}
                  formik={formik}
                  prefix={`additional_locations.${index}`}
                  handleAmountFieldChange={handleAmountFieldChange}
                  index={index}
                />
              ))}
            </form>
          </Box>
        </motion.div>
        <NewProposalFooter
          submitForm={handleCustomSubmit}
          leftGridWidth={leftGridWidth}
          // nextPage={
          //   areRequiredFieldsFilled(formik) &&
          //   !formik.dirty &&
          //   propStep7DataMemoize !== null
          // }
          nextPage={
            formik.values &&
            // Object.values(formik.values).some((value) => value == "") ===
            //   false &&
            hasNull === false &&
            !formik.dirty &&
            propStep7DataMemoize !== null
          }
          handleSaveDraft={handleSaveDraft}
          disableDraft={disableDraft}
        />
      </section>
    </>
  );
};

export default StepSevenForm;
